export function makeNonBreaking(text: string): string {
  return text ? text.replaceAll(/\s/g, "\u00a0") : "";
}
